<!--
 * @Description: 转签约
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-02-17 14:31:41
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <a-form ref="formRef" name="advanced_search" :model="form">
        <dc-layout-card title="转成交客户（至少填写一个成交商机）" :span="12">
          <template #subTitle>
            <a-button type="primary" @click="hanleAdd" ghost>新增</a-button>
          </template>
          <template v-for="(item, index) in form.saleChance" :key="index">
            <div class="cos-form-line" v-if="index"></div>
            <dc-form-item
              label="子客户代码"
              :span="12"
              :name="['saleChance', index, 'arkCodeId']"
              :rules="{
                message: '请选择',
                required: true
              }"
            >
              <GcCodeSelect
                v-model:label="item.arkCode"
                v-model:value="item.arkCodeId"
                :stage="[3, 4]"
                :cosId="route.query.cosId"
                :requiredCosId="true"
              />
            </dc-form-item>
            <dc-form-item
              label="商机名称"
              :span="12"
              :name="['saleChance', index, 'chanceId']"
              :rules="{
                message: '请选择',
                required: true
              }"
            >
              <businessSelect
                v-model:value="item.chanceId"
                :arkCodeId="item.arkCodeId"
                :statusList="[1, 2, 4]"
                :saleChanceRefId="route.query.cosId"
              />
            </dc-form-item>
            <dc-form-item
              label="首单订单编号"
              :span="12"
              :name="['saleChance', index, 'firstOrderId']"
              :rules="{
                message: '请输入',
                required: true
              }"
            >
              <a-input v-model:value="item.firstOrderId" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item
              label="首单下单时间"
              :span="12"
              :name="['saleChance', index, 'firstOrderTime']"
              :rules="{
                message: '请选择',
                required: true
              }"
            >
              <div class="flex">
                <CosDatePicker v-model:value="item.firstOrderTime" :showTime="true" />
                <a-button
                  type="text"
                  danger
                  style="padding-right: 0px"
                  @click="hanleDel(index)"
                  v-show="form.saleChance && form.saleChance.length > 1"
                  >删除</a-button
                >
              </div>
            </dc-form-item>
          </template>
        </dc-layout-card>
      </a-form>
      <cos-footer-button
        v-model:value="form"
        :formRef="formRef"
        :loading="loading"
        :permissionPage="permissionBasic"
        :resetValue="resetValue"
        :disabled="false"
        @submit="handleSubmit"
      ></cos-footer-button>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { turnTransaction } from '@/api/gucangSales/customerCenter'
import GcCodeSelect from '@/components/GcCodeSelect'
import BusinessSelect from '@/components/BusinessSelect'
import { useRoute, useRouter } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import CosDatePicker from '@/components/CosDatePicker/index'
const route = useRoute()
const router = useRouter()
const formRef = ref()
const form = ref<{
  saleChance: {
    arkCode?: string
    contractCode?: string
    saleChanceubject?: string
    serviceSubject?: number
    cosId?: any
  }[]
}>({
  saleChance: [{}]
})
const loading = ref(false)
const permissionBasic = {
  save: 'fbu_contract_deal_btn'
}
const resetValue = ref({
  saleChance: [{}]
})
const hanleAdd = () => {
  form.value.saleChance.push({})
}
const hanleDel = (index: number) => {
  form.value.saleChance.splice(index, 1)
}
const handleSubmit = () => {
  form.value.saleChance.forEach((item) => (item.cosId = route.query.cosId))
  loading.value = true
  turnTransaction(form.value.saleChance)
    .then((res) => {
      layoutTags.close()
      message.success('操作成功')
      router.push({
        path: '/fbu/contract'
      })
    })
    .finally(() => {
      loading.value = false
    })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuTurnToDeal' }
</script>
